'use client';

import dynamic from 'next/dynamic';

import type { ReactNode } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

declare global {
  interface Window {
    __queryClient?: QueryClient;
  }
}

const ReactQueryDevtoolsProduction = dynamic(
  () =>
    import('@tanstack/react-query-devtools/build/modern/production.js').then(
      (d) => d.ReactQueryDevtools,
    ),
  {
    ssr: false,
  },
);

export const getQueryClient = () => {
  return window.__queryClient;
};

export const LightweightQueryProviderSsr = ({ children }: { children?: ReactNode }) => {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 10 * (60 * 1000),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: false,
        retryOnMount: false,
        retryDelay: 0,
      },
    },
  });

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};
